export default "__VITE_ASSET__g44nU8jX__"